<!-- Retrieved from WAI -->
<div class="header">
  @if (!config.disableYearButtons) {
  <button matIconButton (click)="previousClicked('year')" type="button" aria-label="previous year"
    [disabled]="!previousEnabled('year')">
    <i class="ph ph-caret-double-left" aria-hidden="true"></i>
  </button>
  }

  <button matIconButton (click)="previousClicked('month')" type="button" aria-label="previous month" [disabled]="!previousEnabled('month')">
    <i class="ph ph-caret-left" aria-hidden="true"></i>
  </button>

  <h2 id="id-grid-label" class="month-year" aria-live="polite">{{periodLabel()}}</h2>

  <button matIconButton (click)="nextClicked('month')" type="button" aria-label="next month" [disabled]="!nextEnabled('month')">
    <i class="ph ph-caret-right" aria-hidden="true"></i>
  </button>

   @if (!config.disableYearButtons) {
  <button matIconButton (click)="nextClicked('year')" type="button"aria-label="next year" [disabled]="!nextEnabled('year')">
    <i class="ph ph-caret-double-right" aria-hidden="true"></i>
  </button>
  }
</div>